/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LandInputs */

const en__field_land = /** @type {(inputs: _Field_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const de__field_land = /** @type {(inputs: _Field_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {_Field_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_land = /** @type {((inputs?: _Field_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_land(inputs)
	return de__field_land(inputs)
});